import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import FormError from 'components/FormError';
import { activateInsuranceDevice } from 'api';
import { transformErrorResponse } from 'helpers/errors';

class ActivateInsuranceDevice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: undefined,
      success: undefined,
    };
    this.activate = this.activate.bind(this);
  }

  async activate(e) {
    e.preventDefault();
    const { id } = this.props;

    try {
      this.setState({
        loading: true,
      });

      const response = await activateInsuranceDevice(id);
      if (response.status === 200 || response.status === 201) {
        this.setState({
          success: response.data.id,
        });
      }
    } catch ({ response }) {
      if (response) {
        const error = transformErrorResponse(response.data);
        this.setState({
          error,
        });
      }
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { error, loading, success } = this.state;
    return (
      <React.Fragment>
        <h3>Activate Device</h3>
        <button
          className="btn btn-success mar-r"
          onClick={this.activate}
          disabled={loading}
        >
          Activate
        </button>
        {success && (
          <Link to={`/purchases/${success}/view`}>
            Go to Purchase #{success}
          </Link>
        )}
        {error ? <FormError error={error} /> : null}
      </React.Fragment>
    );
  }
}

export default ActivateInsuranceDevice;
